/* "Barrel" of Http Interceptors */
import { HTTP_INTERCEPTORS } from '@angular/common/http';

import { ExceptionInterceptor } from './exception-interceptor';
import { AuthenticationInterceptor } from './authentication-interceptor';

/** Http interceptor providers in outside-in order */
export const HttpInterceptorProviders = [
  { provide: HTTP_INTERCEPTORS, useClass: AuthenticationInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: ExceptionInterceptor, multi: true }
];



// WEBPACK FOOTER //
// D:/a/1/s/UI/src/app/http-interceptors/index.ts